import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_FOLLOW_UPS_REFRESH: createSagaAction('LEAD_FOLLOW_UPS_REFRESH'),

  LEAD_FOLLOW_UP_CREATE: createSagaAction('LEAD_FOLLOW_UP_CREATE'),
  LEAD_FOLLOW_UP_UPDATE: createSagaAction('LEAD_FOLLOW_UP_UPDATE'),
  LEAD_FOLLOW_UP_DELETE: createSagaAction('LEAD_FOLLOW_UP_DELETE'),

  GET_LEAD_FOLLOW_UP_ACTIVITIES: createSagaAction('GET_LEAD_FOLLOW_UP_ACTIVITIES')
}

// Action Creators
export const actions = {
  leadFollowUpsRefresh: ({ next, leadId }) => ({
    type: constants.LEAD_FOLLOW_UPS_REFRESH.ACTION,
    next,
    leadId
  }),

  createLeadFollowUp: ({ leadId, content, userId }) => ({
    type: constants.LEAD_FOLLOW_UP_CREATE.ACTION,
    leadId,
    content,
    userId
  }),

  updateLeadFollowUp: ({ leadId, followUpId, userId, content }) => ({
    type: constants.LEAD_FOLLOW_UP_UPDATE.ACTION,
    leadId,
    followUpId,
    userId,
    content
  }),

  deleteLeadFollowUp: ({ followUpId, leadId }) => ({
    type: constants.LEAD_FOLLOW_UP_DELETE.ACTION,
    leadId,
    followUpId
  }),

  getLeadFollowUpActivities: ({ followUpId }) => ({
    type: constants.GET_LEAD_FOLLOW_UP_ACTIVITIES.ACTION,
    followUpId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_FOLLOW_UPS_REFRESH.SUCCESS:
      return {
        ...state,
        leadFollowUps: action.payload
      }
    case constants.LEAD_FOLLOW_UP_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_FOLLOW_UP_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_FOLLOW_UP_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_LEAD_FOLLOW_UP_ACTIVITIES.SUCCESS:
      return {
        ...state,
        leadFollowUpActivities: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadFollowUpActions.js